import { panelConfigs } from './panelConfig';
import { envVariables } from './envVariables';
import { usePanelType } from '../hooks/usePanelType';

const environment = process.env.REACT_APP_ENV || 'local';
const panelType = usePanelType();

const envConfig = envVariables[environment][panelType];
const panelConfig = panelConfigs[panelType];

const config = {
  ...envConfig,
  ...panelConfig,
};
export default config;
